/* eslint-disable */
import { requireStates } from "util";
import View from "./xmls.view";
import Presenter from "./xmls.presenter";
import { ConnectComponent2 } from "util";

const initialStates = [
  {
    name: "app.history.xmls",
    url: "/xmls",
    views: {
      "content@app": ConnectComponent2(View, Presenter)
    },
    data: {
      authorization: context =>
        context.user.permissions.includes("view_closed_sales"),
      navigation: {
        priority: 600,
        name: "XMLs da Contabilidade",
        state: "app.history.xmls"
      }
    }
  }
];

const context = require.context("./", true, /\.\/[^/]+\/index\.jsx?$/);
const states = requireStates(context, initialStates);

export { states };



// WEBPACK FOOTER //
// ./src/components/app/history/xmls/index.js